<template>
  <div class="w-100" style="min-height:38px;text-align:left;">
    <b-form>
      <b-form-group label="Fecha de nacimiento" label-for="input-birth">
        <b-form-input 
          v-model="formData.birth" 
          type="date"
          placeholder="yyyy-mm-dd"
          min="0" 
          id="input-birth" 
          :state="$v.formData.birth.$invalid ? false : null "
          :disabled="disabled"
        />
        <b-form-invalid-feedback id="input-birth-feedback">
          Fecha inválida, debe tener formato YYYY-MM-DD
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Correo" label-for="input-email">
        <b-form-input
          v-model="formData.email"
          type="email"
          placeholder="Ej: correo@mail.cl"
          id="input-email"
          aria-describedby="input-email-feedback"
          :state="$v.formData.email.$invalid ? false : null "
          :disabled="disabled"
        />
        <b-form-invalid-feedback id="input-email-feedback">
          Correo inválido
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Teléfono" label-for="input-phone">
        <b-form-input 
          v-model="formData.phone" 
          placeholder="Ej: 912345678" 
          id="input-phone" 
          aria-describedby="input-phone-feedback"
          :state="$v.formData.phone.$invalid ? false : null "
          :disabled="disabled"
        />
        <b-form-invalid-feedback id="input-phone-feedback">
          Teléfono inválido
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Sexo" label-for="input-sex">
        <b-form-select 
          v-model="formData.sex" 
          :options="options.optionsSex" 
          id="input-sex" 
          :disabled="disabled"
        />
      </b-form-group>
      <b-form-group label="Estatura (en centímetros)" label-for="input-height">
        <b-form-input 
          v-model="formData.height" 
          :number="true"
          id="input-height" 
          aria-describedby="input-height-feedback"
          :state="$v.formData.height.$invalid ? false : null "
          :disabled="disabled"
          lazy-formatter
          :formatter="formatter"
        />
        <b-form-invalid-feedback id="input-height-feedback">
          La estatura debe ser un número
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Peso (en kilogramos)" label-for="input-weight">
        <b-form-input 
          v-model="formData.weight" 
          :number="true"
          id="input-weight" 
          aria-describedby="input-weight-feedback"
          :state="$v.formData.weight.$invalid ? false : null "
          :disabled="disabled"
          lazy-formatter
          :formatter="formatter"
        />
        <b-form-invalid-feedback id="input-weight-feedback">
          El peso debe ser un número
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Motivo de consulta (selecciona la principal)"
        label-for="input-motivation"
      >
        <b-form-select
          v-model="formData.motivation"
          :options="options.optionsMotivation"
          id="input-motivation"
          :disabled="disabled"
        />
      </b-form-group>
      <transition>
        <b-form-group
          label="¿Ya estás embarazada?"
          label-for="input-preg"
          v-if="pregnancyCandidate"
        >
          <b-form-select 
            v-model="formData.is_pregnant" 
            :options="options.optionsPregnancy" 
            id="input-preg" 
            :disabled="disabled"
          />
        </b-form-group>
      </transition>
      <transition>
        <b-form-group
          label="¿Cuántas semanas de embarazo tienes?"
          label-for="input-preg-weeks"
          v-if="isPregnant"
        >
          <b-form-input 
            v-model="formData.weeks_pregnancy" 
            :number="true"
            id="input-preg-weeks" 
            aria-describedby="input-preg-weeks-feedback"
            :state="$v.formData.weeks_pregnancy.$invalid ? false : null "
            :disabled="disabled"
            lazy-formatter
            :formatter="formatter"
          />
          <b-form-invalid-feedback id="input-preg-weeks-feedback">
            Debe ingresar un número
          </b-form-invalid-feedback>
        </b-form-group>
      </transition>
      <b-form-group 
        label="Marque si es que sufre alguna de las siguientes enfermedades:"
        label-for="input-disease">
        <b-form-checkbox-group id="input-disease" 
          v-model="formData.disease" 
          :options="options.optionsDisease"
          :disabled="disabled"
        />
      </b-form-group>
      <transition name="other-field-transition">
        <b-form-group
          v-if="otherDiseaseSelected"
          label="Indica tus otras enfermedades"
          label-for="input-disease_detail"
        >
          <b-form-textarea 
            id="input-disease_detail" 
            v-model="formData.disease_detail" 
            rows="2" 
            max-rows="2" 
            no-resize
            aria-describedby="input-disease_detail-feedback"
            :state="$v.formData.disease_detail.$invalid ? false : null "
            :disabled="disabled"
          />
          <b-form-invalid-feedback id="input-disease_detail-feedback">
            El texto es demasiado largo
          </b-form-invalid-feedback>
        </b-form-group>
      </transition>
      <transition name="other-field-transition">
        <b-form-group 
          v-if="isTestosteroneCandidate"
          label="Marque si es que sufre alguno de los siguientes síntomas:"
          label-for="input-testosterone">
          <b-form-checkbox-group id="input-testosterone" 
            v-model="formData.testosterone_symptoms" 
            :options="options.optionsTestosterone"
            :disabled="disabled"
          />
        </b-form-group>
      </transition>
      <b-form-group
        label="¿Consumes algún medicamento? De ser así describe los medicamentos, horarios y dosis que consumes"
        label-for="input-medication"
      >
        <b-form-textarea 
          id="input-medication" 
          v-model="formData.medication" 
          rows="2" 
          max-rows="6" 
          aria-describedby="input-medication-feedback"
          :state="$v.formData.medication.$invalid ? false : null "
          :disabled="disabled"
        />
        <b-form-invalid-feedback id="input-medication-feedback">
          El texto es demasiado largo
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Describe tu rutina de trabajo, como: ocupación, horarios, tiempos de viaje, etc."
        label-for="input-work"
      >
        <b-form-textarea 
          id="input-work" 
          v-model="formData.work_schedule" 
          rows="2" 
          max-rows="6" 
          aria-describedby="input-work_schedule-feedback"
          :state="$v.formData.work_schedule.$invalid ? false : null "
          :disabled="disabled"
        />
        <b-form-invalid-feedback id="input-work_schedule-feedback">
          El texto es demasiado largo
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Describe tu rutina de sueño, como: a qué hora te duermes, cuantas hora, calidad del sueño, etc."
        label-for="input-sleep"
      >
        <b-form-textarea 
          id="input-sleep" 
          v-model="formData.sleep_schedule" 
          rows="2" 
          max-rows="6" 
          aria-describedby="input-sleep_schedule-feedback"
          :state="$v.formData.sleep_schedule.$invalid ? false : null "
          :disabled="disabled"
        />
        <b-form-invalid-feedback id="input-sleep_schedule-feedback">
          El texto es demasiado largo
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Agrega información importante sobre tu rutina diaria que no haya sido mencionada"
        label-for="input-extra_info"
      >
        <b-form-textarea 
          id="input-extra_info" 
          v-model="formData.extra_personal_info" 
          rows="2" 
          max-rows="6" 
          aria-describedby="input-extra_info-feedback"
          :state="$v.formData.extra_personal_info.$invalid ? false : null "
          :disabled="disabled"
        />
        <b-form-invalid-feedback id="input-extra_info-feedback">
          El texto es demasiado largo
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>

import { decimal, email, numeric, maxLength } from 'vuelidate/lib/validators'

export default {
  name: "PersonalDataPollComponent",
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      formData: {
        birth: "",
        email: "",
        phone: "",
        height: "",
        weight: "",
        sex: null,
        motivation: null,
        is_pregnant: null,
        weeks_pregnancy: null,
        disease: null,
        disease_detail: "",
        testosterone_symptoms: null,
        medication: null,
        work_schedule: "",
        sleep_schedule: "",
        extra_personal_info: ""
      },
      options: {
        optionsSex: [
          { value: 1, text: "Mascúlino" },
          { value: 2, text: "Femenino" }
        ],
        optionsMotivation: [
          { value: 1, text: "Bajar de peso" },
          { value: 2, text: "Aumentar masa muscular" },
          { value: 3, text: "Mejorar condición deportiva" },
          { value: 4, text: "Mejorar salud" },
          { value: 5, text: "Embarazo saludable" }
        ],
        optionsPregnancy: [
          { value: 1, text: "Sí" },
          { value: 2, text: "No" }
        ],
        optionsDisease: [
          {value: 1, text: "Resistencia a la insulina"},
          {value: 2, text: "Diabetes"},
          {value: 3, text: "Intolerancia a la glucosa"},
          {value: 4, text: "Colesterol alto"},
          {value: 5, text: "Hipertensión"},
          {value: 6, text: "Otro"}
        ],
        optionsTestosterone: [
          {value: 1, text: "Estrés"},
          {value: 2, text: "Sudoración nocturna"},
          {value: 3, text: "Fatiga"},
          {value: 4, text: "Disminución del deseo sexual"}
        ]
      }
    };
  },
  validations: {
    formData:{
      birth:  {
        isDate (value) {
          return value === null || this.$moment(value, "YYYY-MM-DD", true).isValid()
        }   
      },
      email: {
        email
      },
      phone: {
        maxLength: maxLength(50)
      },
      height: {
        decimal
      },
      weight: {
        decimal
      },
      weeks_pregnancy: {
        numeric
      },
      medication: {
        maxLength: maxLength(1000)
      },
      work_schedule: {
        maxLength: maxLength(1000)
      },
      sleep_schedule: {
        maxLength: maxLength(1000)
      },
      disease_detail: {
        maxLength: maxLength(300)
      },
      extra_personal_info: {
        maxLength: maxLength(1000)
      }
    }
  },
  methods: {
    loadData(data) {
      this.formData = data;
    },
    validate: function() {
      this.$v.formData.$touch();
      var isValid = !this.$v.formData.$invalid
      this.$emit('on-validate', isValid, "personalDataPoll")
      return isValid
    },
    getAge(date) {
      if (this.$moment(date, "YYYY-MM-DD", true).isValid()) {
        return this.$moment().diff(date, 'years')
      }
      return 0
    },
    formatter: function (value) {
      if (value === "") {
          return null
        } 
        return value
    }
  },
  computed: {
    otherDiseaseSelected: function () {
      let diseases = this.formData.disease
      if (diseases) {
        return diseases.includes(6)
      }
      return false
    },
    isTestosteroneCandidate: function () {
      let birthDate = this.formData.birth
      let sex = this.formData.sex
      if (birthDate && sex) {
        let age = this.getAge(birthDate)
        if (age>=40 && sex == 1) {
          return true
        }
      } 
      return false
    },
    pregnancyCandidate: function () {
      let motivation = this.formData.motivation
      let sex = this.formData.sex
      return sex === 2 && motivation === 5
    },
    isPregnant: function () {
      let pregnant = this.formData.is_pregnant
      return pregnant === 1 && this.pregnancyCandidate
    }
  }
};
</script>

<style>
.other-field-transition-enter-active,
.other-field-transition-leave-active {
  transition: opacity 0.3s;
}

.other-field-transition-enter,
.other-field-transition-leave-to {
  opacity: 0;
}

.other-field-transition-leave,
.other-field-transition-enter-to {
  opacity: 1;
}
</style>